import { useLayoutEffect, useRef } from "react";
import { useLocation } from "react-router-dom";

import AppRouter from "../router";
import Header from "../components/header";
import Footer from "../components/footer";
import styles from "./layout.module.scss";

// Marketing/public pages get the full footer. The builder, admin, settings,
// the auth flows and public card pages (/:uid) are app screens with their own
// bottom controls, so the footer stays out of the way there.
const FOOTER_ROUTES = ["/", "/shop", "/plans", "/partners", "/blog", "/contact", "/privacy", "/terms"];

const showFooter = (pathname: string) =>
  FOOTER_ROUTES.includes(pathname) || pathname.startsWith("/blog/");

function Layout() {
  const { pathname } = useLocation();
  const withFooter = showFooter(pathname);
  const scrollerRef = useRef<HTMLDivElement>(null);

  // The scroller outlives route changes (pages used to be their own fresh
  // scroll containers), so start every new page at the top.
  useLayoutEffect(() => {
    scrollerRef.current?.scrollTo(0, 0);
  }, [pathname]);

  return (
    <div className={styles.container}>
      <Header />
      {withFooter ? (
        <div ref={scrollerRef} className={`${styles.main} ${styles.scroller}`}>
          <div className={styles.page}>
            <AppRouter />
          </div>
          <Footer />
        </div>
      ) : (
        // App screens keep their own scrolling; this just gives them exactly
        // the space under the header so their sticky bottom bars stay visible.
        <div className={styles.main}>
          <AppRouter />
        </div>
      )}
    </div>
  );
}

export default Layout;
